import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const DELETE_USER_TASK = 'DELETE_USER_TASK';


export const service = async (data) => {
  const options: object = {
    url:  "/Api/UserTasks/DeleteUserTask" ,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(DELETE_USER_TASK, service, mock);
